export const AUDIO_SET_SOUNDS = "AUDIO_SET_SOUNDS";

export function setAudioSounds(data) {
  return {
    type: AUDIO_SET_SOUNDS,
    data,
  };
}



// WEBPACK FOOTER //
// ./src/actions/audio.js